import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Girflriend doesn't mind my love affair",
  "description": "",
  "published": "2008-02-19T00:00:00.000Z",
  "redirect_from": ["/blog/girflriend-doesnt-mind-my-love-affair/swizec/127"],
  "categories": "food for thought, funny",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Just why is it that my bird doesn't mind my having a love affair with Merrick? How could this be? Don't girlfriends usually get terribly upset when their toy has a love affair with someone else?`}</p>
    <p>{`Well no, apparently it depends greatly on whom said love affair it's with. We can probably postulate that a girlfriend would get quite greatly upset if you were to fall in love with, say, her best friend or someone of similar ilk. We probably would not be far from the truth even if we were to say that she'd be upset over your falling in love with pretty much any woman other than herself. Girls have this weird notion implanted in their brains that it's impossible to love more than one person at once ... or simply put ... us regular human males just aren't great enough to be shared and so the whole man is needed to support the desires of a single female.`}</p>
    <p>{`But it does seem to make it all alright if `}<em parentName="p">{`Merrick`}</em>{` happens to be a computer rather than an actual person. Sure, call me a geekity geek for naming my computers and abiding by use of their proper given names but what the hell. I spend more time with them than with actual humans anyway, so why not personify them? Writers do it all the time, hell, we oft do it in regular speech as well!`}</p>
    <p>{`So scree you all! My laptop is called Merrick and my desktop computer is called Lestat and I don't care what you say think or do.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      